import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, CarFrontIcon, HandshakeIcon, BanknoteIcon, ClockIcon, ShieldOffIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
const ICONS = [SparklesIcon, CarFrontIcon, HandshakeIcon, BanknoteIcon, ClockIcon, ShieldOffIcon];
export function MethodSteps() {
  const {
    t
  } = useLanguage();
  return <div className="my-8 grid gap-px border border-ink/20 bg-ink/20 sm:grid-cols-2 lg:grid-cols-3" data-id="element-54" data-mp="7hg5w6xh0foz">
      {t.ch5.steps.map((step, i) => {
      const Icon = ICONS[i] ?? SparklesIcon;
      return <motion.article key={step.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i * 0.07,
        ease: 'easeOut'
      }} className="bg-paper p-5" data-id="element-55" data-mp="3tvr86dy5ctlb" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-56" data-mp="lf4spkb3lwwo">
              <Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-57" data-mp="1278eq1ym0fv6" />
              <span className="font-serif text-2xl font-black text-ink/15" data-id="element-58" data-mp="169c29oyjzawt">
                {String(i + 1).padStart(2, '0')}
              </span>
            </div>
            <h3 className="mt-3 font-sans text-sm font-bold uppercase tracking-[0.1em]" data-id="element-59" data-mp="shfc3qgg3b32">
              {step.title}
            </h3>
            <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-60" data-mp="xep2b8bnrqry">{step.text}</p>
          </motion.article>;
    })}
    </div>;
}